import { db } from "services/firebase";

function sortByUpdatedAt(rows) {
  return [...rows].sort((a, b) => {
    const aTime = a.updatedAt?.toMillis?.() || 0;
    const bTime = b.updatedAt?.toMillis?.() || 0;
    return bTime - aTime;
  });
}

export async function listSavedReportsForUser(uid) {
  if (!uid) return [];

  const [ownedSnap, sharedSnap] = await Promise.all([
    db
      .collection("savedReports")
      .where("uid", "==", uid)
      .orderBy("updatedAt", "desc")
      .get(),
    db
      .collection("savedReports")
      .where("sharedWith", "array-contains", uid)
      .orderBy("updatedAt", "desc")
      .get(),
  ]);

  const byId = new Map();
  [...ownedSnap.docs, ...sharedSnap.docs].forEach((doc) => {
    byId.set(doc.id, { id: doc.id, ...doc.data() });
  });

  return sortByUpdatedAt(Array.from(byId.values()));
}

export async function createSavedReport({ uid, institutionId, name, filters }) {
  if (!uid || !institutionId || !name) {
    throw new Error("uid, institutionId, and name are required.");
  }

  const now = new Date();
  const docRef = await db.collection("savedReports").add({
    uid,
    institutionId,
    name,
    filters,
    sharedWith: [],
    createdAt: now,
    updatedAt: now,
  });

  return docRef.id;
}

export async function deleteSavedReport(viewId) {
  if (!viewId) return;
  await db.collection("savedReports").doc(viewId).delete();
}

async function getUserInstitutionId(targetUid) {
  const snap = await db.collection("users").doc(targetUid).get();
  if (!snap.exists) return "";
  const data = snap.data() || {};
  return (
    data.activeInstitutionId ||
    data.hierarchyInstitutionId ||
    data.institutionId ||
    data.organizationId ||
    ""
  );
}

export async function shareSavedReport(viewId, targetUid, institutionId) {
  if (!viewId || !targetUid) {
    throw new Error("viewId and targetUid are required.");
  }

  const targetInstitutionId = await getUserInstitutionId(targetUid);
  if (!targetInstitutionId || targetInstitutionId !== institutionId) {
    throw new Error("You can only share views with users in your institution.");
  }

  const ref = db.collection("savedReports").doc(viewId);
  const snap = await ref.get();
  if (!snap.exists) {
    throw new Error("Saved view not found.");
  }

  const data = snap.data() || {};
  const sharedWith = Array.isArray(data.sharedWith) ? data.sharedWith : [];
  if (!sharedWith.includes(targetUid)) {
    sharedWith.push(targetUid);
  }

  await ref.update({
    sharedWith,
    updatedAt: new Date(),
  });
}

export async function getSavedReport(viewId) {
  if (!viewId) return null;
  const snap = await db.collection("savedReports").doc(viewId).get();
  if (!snap.exists) return null;
  return { id: snap.id, ...snap.data() };
}
